<template>
	<v-dialog v-model="dialog" max-width="800px" max-height="800px">
		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">見積詳細</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-row no-gutters class="ma-4" justify="end">
				<v-btn v-if="record.matter_id" color="secondary" class="ma-1" @click="openRelatedMatterPage"
					>関連案件
				</v-btn>
				<v-btn color="secondary" class="ma-1" @click="editDialogOpen"
					><v-icon>mdi-pencil</v-icon> 回答入力
				</v-btn>
			</v-row>
			<v-tabs v-model="model">
				<v-tab href="#tab-1">
					<v-card-title>基本情報</v-card-title>
				</v-tab>
				<v-tab href="#tab-2">
					<v-card-title>依頼先情報</v-card-title>
				</v-tab>
				<v-tab href="#tab-3">
					<v-card-title>依頼内容</v-card-title>
				</v-tab>
				<v-tab href="#tab-4">
					<v-card-title>回答情報</v-card-title>
				</v-tab>
				<v-tabs-items v-model="model">
					<v-tab-item value="tab-1">
						<v-card-text>
							<v-data-table
								:headers="headers"
								:items="baseItems"
								hide-default-footer
								class="elevation-1"
							>
								<template v-slot:items="props">
									<td>{{ props.item.label }}</td>
									<td>{{ props.item.value }}</td>
								</template>
							</v-data-table>
						</v-card-text>
					</v-tab-item>
					<v-tab-item value="tab-2">
						<v-card-text>
							<v-data-table
								:headers="headers"
								:items="supplierItems"
								hide-default-footer
								class="elevation-1"
							>
								<template v-slot:items="props">
									<td>{{ props.item.label }}</td>
									<td>{{ props.item.value }}</td>
								</template>
							</v-data-table>
						</v-card-text>
					</v-tab-item>
					<v-tab-item value="tab-3">
						<v-card-text>
							<v-data-table
								:headers="headers"
								:items="quoteItems"
								hide-default-footer
								class="elevation-1"
							>
								<template v-slot:items="props">
									<td>{{ props.item.label }}</td>
									<td>{{ props.item.value }}</td>
								</template>
							</v-data-table>
						</v-card-text>
					</v-tab-item>
					<v-tab-item value="tab-4">
						<v-card-text>
							<v-data-table
								:headers="headers"
								:items="answerItems"
								hide-default-footer
								class="elevation-1"
							>
								<template v-slot:items="props">
									<td>{{ props.item.label }}</td>
									<td>{{ props.item.value }}</td>
								</template>
							</v-data-table>
						</v-card-text>
					</v-tab-item>
				</v-tabs-items>
			</v-tabs>
		</v-card>
		<EditDialog ref="edit" @reloadIndex="reloadIndex" />
	</v-dialog>
</template>

<script>
import EditDialog from "./EditDialog.vue"

export default {
	props: {
		record: {
			type: Object,
			required: true,
		},
		dialog: {
			type: Boolean,
			required: true,
			default: false,
		},
	},
	components: {
		EditDialog,
	},
	data: () => ({
		model: "tab-1",
		statusTypes: [
			{ name: "依頼済み", value: "sent" },
			{ name: "回答取得済", value: "answered" },
		],
		headers: [
			{ text: "項目", value: "label", width: "30%" },
			{ text: "内容", value: "value", width: "70%" },
		],
		baseItems: [],
		supplierItems: [],
		quoteItems: [],
		answerItems: [],
	}),
	methods: {
		reloadIndex() {
			this.$emit("reloadIndex")
			this.closeDialog()
		},
		closeDialog() {
			this.$emit("closeDialog")
		},
		openRelatedMatterPage() {
			window.open("/matters/" + this.record.matter_id, "_blank")
		},
		editDialogOpen() {
			this.$refs.edit.openDialog(this.record)
		},
		statusToJapanese(word) {
			return this.statusTypes.find((type) => type.value === word).name
		},
	},
	components: {
		EditDialog,
	},
	watch: {
		dialog(val) {
			if (!val) {
				// ダイアログが閉じられたときにitemsをリセット
				this.baseItems = []
				this.supplierItems = []
				this.quoteItems = []
				this.answerItems = []
			} else {
				// ダイアログが開かれたときにitemsを更新
				this.baseItems = [
					{ label: "状態", value: this.statusToJapanese(this.record.status_type) },
					{ label: "見積番号", value: this.record.quote_number },
					{ label: "見積日", value: this.record.quote_date },
					{ label: "回答日", value: this.record.answer_date },
				]
				this.supplierItems = [
					{ label: "会社名", value: this.record.supplier.full_name },
					{ label: "電話番号", value: this.record.supplier.tell },
					{ label: "FAX番号", value: this.record.supplier.fax },
					{ label: "担当者名", value: this.record.supplier.pic_name },
					{ label: "担当者Email", value: this.record.supplier.email },
				]
				this.quoteItems = [
					{
						label: "向け先",
						value:
							this.record.logi_quote.prefecture +
							this.record.logi_quote.city +
							this.record.logi_quote.address,
					},
					{ label: "車種", value: this.record.logi_quote.car_model },
					{ label: "台数", value: this.record.logi_quote.number_of_cars },
				]
				this.answerItems = [
					{ label: "単価", value: this.record.logi_quote.price?.toLocaleString() },
					{
						label: "有効期限",
						value: this.record.quote_expiration_period
							? this.record.quote_expiration_period + "日"
							: "",
					},
				]
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.v-data-table {
	.v-data-table__wrapper {
		overflow: auto;
	}
}
</style>
